export const MOCK_ENTITIES_RESULT = {
	data: {
		graphStore: {
			cypherQueryV2: {
				edges: [
					{
						node: {
							__typename: 'GraphStoreCypherQueryV2Node',
							columns: [
								{
									key: 'entity',
									value: {
										id: 'ari:cloud:jira:12e73ff5-8b07-4b31-be8e-67ee0666fc43:issue/444786',
										data: {
											__typename: 'JiraIssue',
											JiraIssue_id:
												'ari:cloud:jira:12e73ff5-8b07-4b31-be8e-67ee0666fc43:issue/444786',
											JiraIssue_issueId: '444786',
											JiraIssue_key: 'GI-2020',
											JiraIssue_webUrl: 'https://softwareteams.atlassian.net/browse/GI-2020',
											JiraIssue_issueTypeAvatarUrl:
												'https://softwareteams.atlassian.net/rest/api/2/universal_avatar/view/type/issuetype/avatar/10318?size=medium',
											JiraIssue_summary: 'Dark Mode 🌖',
											JiraIssue_isArchived: false,
											JiraIssue_archivedOn: null,
											JiraIssue_isResolved: false,
											JiraIssue_canCreateSubtask: true,
											JiraIssue_canBeExported: true,
											JiraIssue_canDownloadAttachment: true,
											JiraIssue_shouldShowPlaybooks: false,
											JiraIssue_exceededChildIssueLimit: false,
											JiraIssue_hasChildIssues: false,
											JiraIssue_configurationUrl:
												'https://softwareteams.atlassian.net/https:/confluence.atlassian.com/jirasoftwarecloud/configure-field-layout-in-the-issue-view-961798059.html',
											JiraIssue_lastViewedTimestamp: null,
											JiraIssue_hasCustomisedContentPanels: false,
											JiraIssue_mercuryProjectName: 'Dark Mode 🌖',
											JiraIssue_mercuryProjectUrl:
												'https://softwareteams.atlassian.net/browse/GI-2020',
											JiraIssue_mercuryProjectKey: 'GI-2020',
											JiraIssue_mercuryProjectIcon:
												'https://softwareteams.atlassian.net/rest/api/2/universal_avatar/view/type/issuetype/avatar/10318?size=medium',
											JiraIssue_mercuryProjectProviderName: 'JIRA',
											JiraIssue_mercuryTargetDateStart: null,
											JiraIssue_mercuryTargetDateEnd: null,
											JiraIssue_mercuryTargetDateType: 'DAY',
											JiraIssue_lastRedactionTime: null,
											JiraIssue_dueDateField: {
												id: 'ari:cloud:jira:12e73ff5-8b07-4b31-be8e-67ee0666fc43:issuefieldvalue/444786/duedate',
											},
											JiraIssue_startDateField: null,
											JiraIssue_projectField: {
												id: 'ari:cloud:jira:12e73ff5-8b07-4b31-be8e-67ee0666fc43:issuefieldvalue/444786/project',
											},
											JiraIssue_parentIssueField: {
												id: 'ari:cloud:jira:12e73ff5-8b07-4b31-be8e-67ee0666fc43:issuefieldvalue/444786/parent',
											},
											JiraIssue_assigneeField: {
												id: 'ari:cloud:jira:12e73ff5-8b07-4b31-be8e-67ee0666fc43:issuefieldvalue/444786/assignee',
											},
											JiraIssue_summaryField: {
												id: 'ari:cloud:jira:12e73ff5-8b07-4b31-be8e-67ee0666fc43:issuefieldvalue/444786/summary',
											},
											JiraIssue_issueRestrictionField: {
												id: 'ari:cloud:jira:12e73ff5-8b07-4b31-be8e-67ee0666fc43:issuefieldvalue/444786/issuerestriction',
											},
											JiraIssue_issueType: {
												id: 'ari:cloud:jira:12e73ff5-8b07-4b31-be8e-67ee0666fc43:issue-type/12805',
											},
											JiraIssue_issueTypeField: {
												id: 'ari:cloud:jira:12e73ff5-8b07-4b31-be8e-67ee0666fc43:issuefieldvalue/444786/issuetype',
											},
											JiraIssue_status: {
												id: 'SmlyYVN0YXR1czoxNDMxNw',
											},
											JiraIssue_statusField: {
												id: 'ari:cloud:jira:12e73ff5-8b07-4b31-be8e-67ee0666fc43:issuefieldvalue/444786/status',
											},
											JiraIssue_statusCategory: {
												id: 'SmlyYVN0YXR1c0NhdGVnb3J5OjI',
											},
											JiraIssue_priorityField: {
												id: 'ari:cloud:jira:12e73ff5-8b07-4b31-be8e-67ee0666fc43:issuefieldvalue/444786/priority',
											},
											JiraIssue_descriptionField: {
												id: 'ari:cloud:jira:12e73ff5-8b07-4b31-be8e-67ee0666fc43:issuefieldvalue/444786/description',
											},
											JiraIssue_createdField: {
												id: 'ari:cloud:jira:12e73ff5-8b07-4b31-be8e-67ee0666fc43:issuefieldvalue/444786/created',
											},
											JiraIssue_updatedField: {
												id: 'ari:cloud:jira:12e73ff5-8b07-4b31-be8e-67ee0666fc43:issuefieldvalue/444786/updated',
											},
											JiraIssue_resolutionField: {
												id: 'ari:cloud:jira:12e73ff5-8b07-4b31-be8e-67ee0666fc43:issuefieldvalue/444786/resolution',
											},
											JiraIssue_resolutionDateField: {
												id: 'ari:cloud:jira:12e73ff5-8b07-4b31-be8e-67ee0666fc43:issuefieldvalue/444786/resolutiondate',
											},
											JiraIssue_securityLevelField: {
												id: 'ari:cloud:jira:12e73ff5-8b07-4b31-be8e-67ee0666fc43:issuefieldvalue/444786/security',
											},
											JiraIssue_timeTrackingField: {
												id: 'ari:cloud:jira:12e73ff5-8b07-4b31-be8e-67ee0666fc43:issuefieldvalue/444786/timetracking',
											},
											JiraIssue_timeOriginalEstimateField: null,
											JiraIssue_votesField: {
												id: 'ari:cloud:jira:12e73ff5-8b07-4b31-be8e-67ee0666fc43:issuefieldvalue/444786/votes',
											},
											JiraIssue_watchesField: {
												id: 'ari:cloud:jira:12e73ff5-8b07-4b31-be8e-67ee0666fc43:issuefieldvalue/444786/watches',
											},
											JiraIssue_atlassianProjectField: null,
											JiraIssue_issueColorField: null,
											JiraIssue_storyPointsField: null,
											JiraIssue_storyPointEstimateField: {
												id: 'ari:cloud:jira:12e73ff5-8b07-4b31-be8e-67ee0666fc43:issuefieldvalue/444786/customfield_10955',
											},
											JiraIssue_confluenceRemoteIssueLinksField: {
												id: 'ari:cloud:jira:12e73ff5-8b07-4b31-be8e-67ee0666fc43:issuefieldvalue/444786/confluenceRemoteIssueLinks',
											},
											JiraIssue_childIssues: null,
											JiraIssue_jiraCoverMedia: null,
											JiraIssue_mercuryProjectStatus: {
												__typename: 'JiraStatusCategory',
											},
											JiraIssue_mercuryOriginalProjectStatus: {
												__typename: 'JiraStatus',
											},
											JiraIssue_mercuryProjectType: {
												__typename: 'JiraIssueType',
											},
											JiraIssue_mercuryProjectOwner: {
												__typename: 'AtlassianAccountUser',
											},
											JiraIssue_reporter: {
												__typename: 'AtlassianAccountUser',
											},
											JiraIssue_archivedBy: null,
											JiraIssue_summarisedBuilds: null,
											JiraIssue_summarisedDeployments: null,
										},
									},
								},
							],
						},
					},
					{
						node: {
							__typename: 'GraphStoreCypherQueryV2Node',
							columns: [
								{
									key: 'entity',
									value: {
										id: 'ari:cloud:loom:a436116f-02ce-4520-8fbb-7301462a1674:video/activation/1621dc1f-3702-4525-84ba-fad829566798/06a73e664945465b9908061ed64771bf',
										data: {
											__typename: 'LoomVideo',
											LoomVideo_id:
												'ari:cloud:loom:a436116f-02ce-4520-8fbb-7301462a1674:video/activation/1621dc1f-3702-4525-84ba-fad829566798/06a73e664945465b9908061ed64771bf',
											LoomVideo_name: 'Sync on TWG Labs status',
											LoomVideo_isArchived: false,
											LoomVideo_isComplete: true,
											LoomVideo_url: 'https://www.loom.com/share/06a73e664945465b9908061ed64771bf',
											LoomVideo_description:
												'\n\n### Discussion on personal updates and conference 11:23\n\n- Namkai Fairfield shared that a friend from Japan is visiting for two weeks and will attend a TypeScript AI conference in San Francisco.\n- Benjamin Schaap expressed interest and commented on the conference, noting it sounded "lame" but was supportive of Namkai\'s friendships.\n- Namkai mentioned the conference is organized by the creators of Gatsby.\n\n### Work-related messages and communication 11:30\n\n- Benjamin Schaap apologized for sending multiple messages to Namkai while unaware that Namkai was unavailable.\n- Namkai acknowledged the messages and indicated there were no issues.\n- Benjamin mentioned the messages were mostly informal and involved "throwing shade" at people.',
											LoomVideo_ownerId: '712020:a5e9d3e4-843b-4db9-ae21-1dfb9f00b015',
											LoomVideo_transcriptLanguage: 'en',
											LoomVideo_isMeeting: true,
											LoomVideo_meetingAri:
												'ari:cloud:loom:a436116f-02ce-4520-8fbb-7301462a1674:meeting/activation/1621dc1f-3702-4525-84ba-fad829566798/641d5f4f-8c26-4bd5-8069-d09fa31fac37',
											LoomVideo_collaborators: [
												'nfairfield@atlassian.com',
												'bschaap@atlassian.com',
											],
											LoomVideo_sourceDuration: 723.43,
											LoomVideo_playableDuration: 723.43,
											LoomVideo_commentCount: 0,
											LoomVideo_reactionCount: 0,
											LoomVideo_createdAt: '2025-11-06T00:30:21.308Z',
											LoomVideo_updatedAt: '2025-11-06T00:42:42.964Z',
											LoomVideo_owner: {
												__typename: 'AtlassianAccountUser',
											},
										},
									},
								},
							],
						},
					},
					{
						node: {
							__typename: 'GraphStoreCypherQueryV2Node',
							columns: [
								{
									key: 'entity',
									value: {
										id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/6027622239',
										data: {
											__typename: 'ConfluencePage',
											ConfluencePage_createdAt: '2025-10-31T00:04:26.309Z',
											ConfluencePage_id:
												'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/6027622239',
											ConfluencePage_pageId: '6027622239',
											ConfluencePage_status: 'CURRENT',
											ConfluencePage_subtype: null,
											ConfluencePage_title: 'Teamwork Graph Labs Roadmap Q2',
											ConfluencePage_type: 'PAGE',
											ConfluencePage_ancestors: [
												{
													id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/2751272732',
												},
												{
													id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/3747787847',
												},
												{
													id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/4185525992',
												},
												{
													id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:page/4491170307',
												},
											],
											ConfluencePage_author: {
												id: 'ari:cloud:identity::user/712020:a5e9d3e4-843b-4db9-ae21-1dfb9f00b015',
											},
											ConfluencePage_labels: [],
											ConfluencePage_owner: {
												id: 'ari:cloud:identity::user/712020:a5e9d3e4-843b-4db9-ae21-1dfb9f00b015',
											},
											ConfluenceSpace_space: {
												id: 'ari:cloud:confluence:a436116f-02ce-4520-8fbb-7301462a1674:space/2751272599',
											},
											links: {
												base: 'https://hello.atlassian.net/wiki',
												webUi: '/spaces/TEAMGRAPH/pages/6027622239/Teamwork+Graph+Labs+Roadmap+Q2',
											},
										},
									},
								},
							],
						},
					},
				],
			},
		},
	},
	extensions: {
		gateway: {
			request_id: 'entities-mock-request-id',
			tId: 'entities-mock-trace-id',
			crossRegion: false,
			edgeCrossRegion: false,
		},
	},
} as const;
